import axios from 'axios';

// The app's axios interceptor resolves 4xx responses instead of rejecting them, so both a resolved
// error response and a rejection are normalised here. The global error flash is suppressed because
// the caller shows errors itself.
const REQUEST = { suppressErrorFlash: true };
const FALLBACK_ERROR = 'The accounting settings could not be loaded or saved.';

// Success -> { data }. Failure -> { status, errors } where errors is a field map for a 422 with
// field errors, otherwise a string message. A 403 carries only { status }.
const normalize = (response, error) => {
  if (response && response.status < 400) return { data: response.data };
  if (response?.status === 403) return { status: 403 };
  const data = response?.data || {};
  const status = response?.status;
  if (data.errors && typeof data.errors === 'object' && !Array.isArray(data.errors)) {
    return { status, errors: data.errors };
  }
  return { status, errors: (typeof data.errors === 'string' && data.errors) || data.message || error?.message || FALLBACK_ERROR };
};

const request = async (call) => {
  try {
    return normalize(await call());
  } catch (e) {
    return normalize(e?.response, e);
  }
};

export const getAccountingSettings = () => request(() => axios.get('/accounting-settings', REQUEST));

export const updateAccountingSettings = ({ deposit_hold_business_hours, deposit_hold_approval_threshold }) => {
  const threshold = deposit_hold_approval_threshold;
  return request(() =>
    axios.put(
      '/accounting-settings',
      {
        deposit_hold_business_hours,
        deposit_hold_approval_threshold: threshold === '' || threshold === undefined || threshold === null ? null : threshold,
      },
      REQUEST,
    ),
  );
};
